import { render, staticRenderFns } from "./accountDetail.vue?vue&type=template&id=2d62d1b8&scoped=true"
import script from "./accountDetail.vue?vue&type=script&lang=js"
export * from "./accountDetail.vue?vue&type=script&lang=js"
import style0 from "./accountDetail.vue?vue&type=style&index=0&id=2d62d1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d62d1b8",
  null
  
)

export default component.exports